import { RawApi } from '.';
import { Tournaments } from '@/components/Sport/types';
import { ValidationError } from './apiError';
import { navigationApiResponse } from './validators/navigation';
import { isLeft } from 'fp-ts/lib/Either';
import { convertNavigation } from './converters/navigation';
import { config } from '@/config';
import store from '@/store';

export interface NavigationAPI {
  fetchNavigation: () => Promise<Tournaments>;
}

export class NavigationApi extends RawApi implements NavigationAPI {
  public async fetchNavigation(): Promise<any> {
    const response = store.state.countryCode
      ? await this.fetchScoresApi(`/content/v5/${config.platform_id}/navigation?region=${store.state.countryCode}`)
      : await this.fetchScoresApi(`/content/v5/${config.platform_id}/navigation`);
    const jsonResponse: unknown = await response.json();
    const navigation = navigationApiResponse.decode(jsonResponse);

    if (isLeft(navigation)) {
      throw new ValidationError('API Response validation failed', 400, navigation);
    }

    const formattedNavigation: Tournaments = convertNavigation(navigation.right);

    return formattedNavigation;
  }
}
